import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ISiteMembersApi, MemberDetails } from 'feature-site-members'
import { SiteMembersApiSymbol } from 'feature-site-members'
import type { LoginButtonFeatureProps } from '@wix/thunderbolt-components'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'

const componentType = 'LoginButton'

const loginButtonPageFactory = (
	siteMembersApi: ISiteMembersApi
): ComponentWillMount<ViewerComponent<LoginButtonFeatureProps>> => {
	const getNewProps = async (memberDetails?: MemberDetails) => {
		const props: LoginButtonFeatureProps = {
			isLoggedIn: false,
			userName: '',
			onLogin: () => {
				siteMembersApi.promptLogin()
			},
			onLogout: () => {
				siteMembersApi.logout()
			},
		}
		if (memberDetails) {
			props.isLoggedIn = true
			props.userName = memberDetails.nickname || memberDetails.memberName || memberDetails.loginEmail
		}
		return props
	}

	return {
		componentTypes: [componentType],
		async componentWillMount({ updateProps }) {
			const updatePropsCallback = async (memberDetails?: MemberDetails) => updateProps(await getNewProps(memberDetails))

			const onLoginCallbackId = siteMembersApi.registerToUserLogin(updatePropsCallback)
			const onMemberDetailsRefreshCallbackId = siteMembersApi.registerToMemberDetailsRefresh(updatePropsCallback)
			try {
				const memberDetails = await siteMembersApi.getMemberDetails()
				updatePropsCallback(memberDetails ?? undefined)
			} catch {
				updatePropsCallback()
			}

			return async () => {
				siteMembersApi.unRegisterToUserLogin(onLoginCallbackId)
				siteMembersApi.unRegisterToMemberDetailsRefresh(onMemberDetailsRefreshCallbackId)
			}
		},
	}
}

export const LoginButtonPage = withDependencies([SiteMembersApiSymbol], loginButtonPageFactory)
